// @flow
// @jsx h

import { h } from "preact";

import { withText } from "preact-i18n";

// Tab component
import Tab from "./Tab";
import TabIcon from "./TabIcon";
import TabLabel from "./TabLabel";

// Icon
import { ExtrasIcon } from "elc-icons";

/**
 * Extras tab component
 */
const ExtrasTab = withText({ label: "header.extras" })(
  ({
    theme,
    active,
    label
  }: {
    theme?: Object,
    active: boolean,
    label: string
  }) => (
    <Tab>
      <TabIcon theme={theme} active={active}>
        <ExtrasIcon />
      </TabIcon>
      <TabLabel theme={theme} active={active} label={label} />
    </Tab>
  )
);

export default ExtrasTab;
